import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1979386c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Add risk note"),
  /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Notes")
], -1))
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "bank-account" }
const _hoisted_5 = { class: "ls-form" }
const _hoisted_6 = { class: "body-line-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Practice risk *", -1))
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = { class: "select mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "- Please select -", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "body-line-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Practice risk indicator *", -1))
const _hoisted_14 = { class: "input-box" }
const _hoisted_15 = { class: "select mb-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "- Please select -", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "body-line-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Risk notes *", -1))
const _hoisted_20 = { class: "controls mt-4" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[5] || (_cache[5] = $event => (_ctx.cancelClicked())),
      mostScreen: true
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("fieldset", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.practiceNote.practiceRisk.id) = $event))
                      }, [
                        _hoisted_10,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceRisks, (pr) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: pr.id
                          }, _toDisplayString(pr.name), 9, _hoisted_11))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.formData.practiceNote.practiceRisk.id]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("fieldset", null, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.formData.practiceNote.practiceRiskIndicator.id) = $event))
                      }, [
                        _hoisted_16,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceRiskIndicators, (prI) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: prI.id
                          }, _toDisplayString(prI.name), 9, _hoisted_17))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.formData.practiceNote.practiceRiskIndicator.id]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("fieldset", null, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.formData.content) = $event)),
                    style: {"resize":"vertical"}
                  }, null, 512), [
                    [_vModelText, _ctx.formData.content]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "btn btn-default ml-1",
              disabled: _ctx.submitting,
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.cancelClicked()), ["prevent","stop"]))
            }, " Back ", 8, _hoisted_21),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
              onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.saveNote()), ["prevent","stop"]))
            }, "Add ", 8, _hoisted_22),
            (_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  class: "loading-indicator",
                  showLoadingText: false
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}